import { render, staticRenderFns } from "./KioskDashboard.vue?vue&type=template&id=87f36ada&"
import script from "./KioskDashboard.vue?vue&type=script&lang=js&"
export * from "./KioskDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "KioskDashboard.vue"
export default component.exports